import script from "./ModalJustificativaTexto.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalJustificativaTexto.vue?vue&type=script&setup=true&lang=js"

import "./ModalJustificativaTexto.vue?vue&type=style&index=0&id=f09f8ab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f09f8ab4"]])

export default __exports__